(function () {
  if (window.TownWineOpenAlert) {
    if (typeof window.TownWineOpenAlert.init === 'function') {
      window.TownWineOpenAlert.init(document);
    }
    return;
  }

  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';
  var loginStateByProxy = Object.create(null);
  var initialized = false;

  function normalizeProductId(value) {
    var rawValue = String(value || '').trim();

    if (!rawValue) return '';

    if (rawValue.indexOf('gid://shopify/Product/') === 0) {
      return rawValue;
    }

    var numericMatches = rawValue.match(/\d+/g);
    var numericId = numericMatches && numericMatches[numericMatches.length - 1];

    return numericId ? 'gid://shopify/Product/' + numericId : '';
  }

  function getAlertButtons(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll('.js-open-alert-btn'));
  }

  function getBulkButtons(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll('.js-open-alert-all-btn'));
  }

  function getProxyBase(node) {
    return (node && node.dataset && node.dataset.proxyBase) || DEFAULT_PROXY_BASE;
  }

  function getProductId(button) {
    return normalizeProductId(button.dataset.productId || '');
  }

  function getReturnTo(node) {
    var fallback = window.location.pathname + window.location.search + window.location.hash;
    return String((node && node.dataset && node.dataset.returnTo) || fallback || '/');
  }

  function getAlertLabel(button) {
    return button.dataset.alertLabel || '오픈 알림';
  }

  function getAlertedLabel(button) {
    return button.dataset.alertedLabel || '알림 ✓';
  }

  function getBulkLabel(button) {
    return button.dataset.bulkLabel || '전체 일괄 알림 받기';
  }

  function getBulkActiveLabel(button) {
    return button.dataset.bulkActiveLabel || '전체 알림 신청됨';
  }

  function setAlertButtonState(button, subscribed) {
    button.setAttribute('aria-pressed', subscribed ? 'true' : 'false');
    button.textContent = subscribed ? getAlertedLabel(button) : getAlertLabel(button);
  }

  function setBulkButtonState(button, allSubscribed) {
    button.setAttribute('aria-pressed', allSubscribed ? 'true' : 'false');
    button.textContent = allSubscribed ? getBulkActiveLabel(button) : getBulkLabel(button);
  }

  function getSection(node) {
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest('[data-townwine-open-alert-section]');
  }

  function getSectionAlertButtons(node) {
    var section = getSection(node);

    if (!section) {
      return getAlertButtons(document);
    }

    return getAlertButtons(section);
  }

  function getSectionProductIds(node) {
    var productIds = [];

    getSectionAlertButtons(node).forEach(function (button) {
      var productId = getProductId(button);
      if (productId && productIds.indexOf(productId) === -1) {
        productIds.push(productId);
      }
    });

    return productIds;
  }

  function setProductButtonsState(proxyBase, productIds, subscribed) {
    var normalizedIds = (productIds || []).map(normalizeProductId);

    getAlertButtons(document).forEach(function (button) {
      var buttonProductId = getProductId(button);
      if (!buttonProductId || getProxyBase(button) !== proxyBase) return;

      if (normalizedIds.indexOf(buttonProductId) !== -1) {
        setAlertButtonState(button, subscribed);
      }
    });
  }

  function setProductButtonsDisabled(proxyBase, productIds, disabled) {
    var normalizedIds = (productIds || []).map(normalizeProductId);

    getAlertButtons(document).forEach(function (button) {
      var buttonProductId = getProductId(button);
      if (!buttonProductId || getProxyBase(button) !== proxyBase) return;

      if (normalizedIds.indexOf(buttonProductId) !== -1) {
        button.disabled = disabled;
      }
    });

    getBulkButtons(document).forEach(function (button) {
      var bulkIds = getSectionProductIds(button);
      var hasMatch = bulkIds.some(function (productId) {
        return normalizedIds.indexOf(productId) !== -1;
      });

      if (hasMatch && getProxyBase(button) === proxyBase) {
        button.disabled = disabled;
      }
    });
  }

  function parseJsonSafely(rawText) {
    if (!rawText) return null;

    try {
      return JSON.parse(rawText);
    } catch (error) {
      console.warn('[open-alert] non-JSON response payload', rawText);
      return null;
    }
  }

  function isLoginRedirect(response) {
    return Boolean(
      response &&
        response.redirected &&
        (response.url.indexOf('/account/login') !== -1 || response.url.indexOf('/password') !== -1),
    );
  }

  function isHtmlResponse(response, rawText) {
    var contentType = (response && response.headers.get('content-type')) || '';

    if (contentType.indexOf('text/html') !== -1) {
      return true;
    }

    return /^\s*</.test(String(rawText || ''));
  }

  function getFriendlyErrorMessage(message, status) {
    if (
      !message ||
      message === 'OPEN_ALERT_SUBSCRIBE_FAILED' ||
      message === 'OPEN_ALERT_UNSUBSCRIBE_FAILED'
    ) {
      if (status) {
        return '오픈 알림 처리 중 오류가 발생했습니다. (HTTP ' + status + ')';
      }

      return '오픈 알림 처리 중 오류가 발생했습니다.';
    }

    if (message === 'PRODUCT_ID_REQUIRED') {
      return '상품 정보가 없어 알림을 처리할 수 없습니다.';
    }

    return message;
  }

  function handleUnauthorized() {
    if (window.self !== window.top) {
      window.alert('테마 미리보기에서는 고객 로그인 세션이 전달되지 않아 알림 테스트가 제한될 수 있습니다. 실제 스토어프론트 프리뷰 URL에서 고객 로그인 후 다시 확인해 주세요.');
      return;
    }

    var returnTo = window.location.pathname + window.location.search + window.location.hash;
    window.location.href = '/account/login?return_url=' + encodeURIComponent(returnTo);
  }

  function fetchStatusSnapshot(proxyBase, productIds) {
    var filteredProductIds = (productIds || []).map(normalizeProductId).filter(Boolean);

    if (!filteredProductIds.length) {
      return Promise.resolve({
        subscribedProductIds: [],
        loggedIn: loginStateByProxy[proxyBase] !== false,
      });
    }

    return fetch(
      proxyBase + '/open-alert-status?productIds=' + encodeURIComponent(filteredProductIds.join(',')),
      {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      },
    ).then(function (response) {
      if (!response.ok || isLoginRedirect(response)) {
        throw new Error('OPEN_ALERT_STATUS_FAILED');
      }

      return response.json();
    });
  }

  function sendMutationRequest(endpoint, payload) {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.text().then(function (rawText) {
        return {
          response: response,
          payload: parseJsonSafely(rawText),
          rawText: rawText,
        };
      });
    });
  }

  function updateBulkButtons(root) {
    getBulkButtons(root || document).forEach(function (button) {
      var sectionButtons = getSectionAlertButtons(button).filter(function (alertButton) {
        return getProxyBase(alertButton) === getProxyBase(button);
      });
      var hasButtons = sectionButtons.length > 0;

      button.disabled = !hasButtons;

      if (!hasButtons) {
        setBulkButtonState(button, false);
        return;
      }

      var allSubscribed = sectionButtons.every(function (alertButton) {
        return alertButton.getAttribute('aria-pressed') === 'true';
      });

      setBulkButtonState(button, allSubscribed);
    });
  }

  function syncStatuses(root) {
    var buttons = getAlertButtons(root || document);
    var groups = new Map();

    buttons.forEach(function (button) {
      var proxyBase = getProxyBase(button);
      var productId = getProductId(button);

      if (!productId) {
        button.disabled = true;
        return;
      }

      if (!groups.has(proxyBase)) {
        groups.set(proxyBase, new Set());
      }

      groups.get(proxyBase).add(productId);
    });

    groups.forEach(function (productIds, proxyBase) {
      var productIdList = Array.from(productIds);
      if (!productIdList.length) return;

      fetchStatusSnapshot(proxyBase, productIdList)
        .then(function (payload) {
          if (!payload || !Array.isArray(payload.subscribedProductIds)) return;

          loginStateByProxy[proxyBase] = payload.loggedIn !== false;

          var subscribedSet = new Set(
            payload.subscribedProductIds.map(function (productId) {
              return normalizeProductId(productId);
            }),
          );

          getAlertButtons(document).forEach(function (button) {
            var buttonProductId = getProductId(button);

            if (!buttonProductId || getProxyBase(button) !== proxyBase) return;

            setAlertButtonState(button, subscribedSet.has(buttonProductId));
          });

          updateBulkButtons(document);
        })
        .catch(function (error) {
          console.warn('[open-alert] failed to sync statuses', error);
        });
    });
  }

  function resolveLoggedInState(proxyBase, productIds) {
    if (loginStateByProxy[proxyBase] != null) {
      return Promise.resolve(loginStateByProxy[proxyBase] !== false);
    }

    return fetchStatusSnapshot(proxyBase, productIds)
      .then(function (payload) {
        loginStateByProxy[proxyBase] = payload && payload.loggedIn !== false;
        return loginStateByProxy[proxyBase] !== false;
      })
      .catch(function (error) {
        console.warn('[open-alert] failed to resolve login state', error);
        return true;
      });
  }

  function applyMutationResult(proxyBase, productIds, subscribed, result) {
    var response = result.response;
    var payload = result.payload;
    var rawText = result.rawText;

    if (response.status === 401) {
      loginStateByProxy[proxyBase] = false;
      handleUnauthorized();
      return;
    }

    if ((payload && payload.message === 'LOGIN_REQUIRED') || rawText === 'LOGIN_REQUIRED' || isLoginRedirect(response)) {
      loginStateByProxy[proxyBase] = false;
      handleUnauthorized();
      return;
    }

    if (isHtmlResponse(response, rawText)) {
      throw new Error('오픈 알림 처리 중 오류가 발생했습니다.');
    }

    if (!response.ok || (payload && payload.ok === false)) {
      throw new Error(getFriendlyErrorMessage(payload && payload.message, response.status));
    }

    loginStateByProxy[proxyBase] = true;
    setProductButtonsState(proxyBase, productIds, subscribed);
    updateBulkButtons(document);
    syncStatuses(document);

    document.dispatchEvent(
      new CustomEvent('townwine:open-alert-change', {
        detail: {
          proxyBase: proxyBase,
          productIds: productIds,
          subscribed: subscribed,
        },
      }),
    );
  }

  function handleAlertMutation(node, productIds, subscribed) {
    var proxyBase = getProxyBase(node);

    setProductButtonsDisabled(proxyBase, productIds, true);

    resolveLoggedInState(proxyBase, productIds)
      .then(function (isLoggedIn) {
        if (!isLoggedIn) {
          handleUnauthorized();
          return null;
        }

        var endpoint = proxyBase + (subscribed ? '/open-alert' : '/open-alert-unsubscribe');

        return sendMutationRequest(endpoint, {
          productIds: productIds,
          returnTo: getReturnTo(node),
        }).then(function (result) {
          return { result: result, proxyBase: proxyBase };
        });
      })
      .then(function (state) {
        if (!state) return;
        applyMutationResult(state.proxyBase, productIds, subscribed, state.result);
      })
      .catch(function (error) {
        console.error('[open-alert] request failed', error);
        window.alert(getFriendlyErrorMessage(error && error.message));
      })
      .finally(function () {
        setProductButtonsDisabled(proxyBase, productIds, false);
      });
  }

  function handleAlertClick(button) {
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    var productId = getProductId(button);
    if (!productId) {
      window.alert('상품 정보가 없어 알림을 처리할 수 없습니다.');
      return;
    }

    var subscribed = button.getAttribute('aria-pressed') !== 'true';
    handleAlertMutation(button, [productId], subscribed);
  }

  function handleBulkClick(button) {
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    var productIds = getSectionProductIds(button);
    if (!productIds.length) {
      window.alert('알림을 신청할 예정 공구가 없습니다.');
      return;
    }

    var subscribed = button.getAttribute('aria-pressed') !== 'true';
    handleAlertMutation(button, productIds, subscribed);
  }

  function bindAlertButton(button) {
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.dataset.openAlertBound === 'true') return;

    button.dataset.openAlertBound = 'true';
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      handleAlertClick(button);
    });
  }

  function bindBulkButton(button) {
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.dataset.openAlertBulkBound === 'true') return;

    button.dataset.openAlertBulkBound = 'true';
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      handleBulkClick(button);
    });
  }

  function initializeButtons(root) {
    getAlertButtons(root || document).forEach(function (button) {
      bindAlertButton(button);

      if (!getProductId(button)) {
        button.disabled = true;
      }
    });

    getBulkButtons(root || document).forEach(function (button) {
      bindBulkButton(button);
    });

    syncStatuses(root || document);
    updateBulkButtons(root || document);
  }

  function initialize() {
    if (!initialized) {
      initialized = true;
      document.addEventListener('shopify:section:load', function (event) {
        initializeButtons(event.target);
      });
    }

    initializeButtons(document);
  }

  window.TownWineOpenAlert = {
    init: initializeButtons,
    syncStatuses: syncStatuses,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
